<template>
  <div>
    <el-button type="primary" @click="deliveryPrint">打印</el-button>
    <el-button type="primary" :loading="deliveryLoading" @click="deliveryPrint2">excel打印</el-button>
    <el-button type="primary" :loading="addSaleLoading" @click="addSaleForm">创建销单</el-button>
    <el-button type="success" @click="copyBill">复制此单</el-button>
    <el-button type="primary" :loading="addCsSpecialLoading" @click="addCsSpecialApplication">特殊申请</el-button>
    <el-tabs style="margin-top: 3px" type="border-card">
      <el-tab-pane label="基础信息">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{replacementBillVo.billNo}}</td>
            <td class="tableLabel">客户单号：</td>
            <td>{{replacementBillVo.customerBillNo}}</td>
            <td class="tableLabel">登记日期：</td>
            <td>{{replacementBillVo.createTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">下单人：</td>
            <td>{{replacementBillVo.creatorName}}</td>
            <td class="tableLabel">客户名称：</td>
            <td>{{replacementBillVo.customerName}}</td>
            <td class="tableLabel">出厂编号：</td>
            <td>{{replacementBillVo.salesOrderNo}}</td>
          </tr>
          <tr>
            <td class="tableLabel">现场人员：</td>
            <td>{{replacementBillVo.contact}}</td>
            <td class="tableLabel">电梯编号：</td>
            <td>{{replacementBillVo.elevatorNo}}</td>
            <td class="tableLabel">项目名称：</td>
            <td>{{replacementBillVo.siteName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">收货人：</td>
            <td>{{replacementBillVo.consignee}}</td>
            <td class="tableLabel">联系方式-收货：</td>
            <td>{{replacementBillVo.consigneeMobile}}</td>
            <td class="tableLabel">快递方式：</td>
            <td>
              <el-select v-model="replacementBillVo.deliveryType" disabled filterable placeholder="请选择">
                <el-option
                    v-for="item in constants.deliveryType.$options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">销售员：</td>
            <td>{{replacementBillVo.salesMan}}</td>
            <td class="tableLabel">运费是否到付：</td>
            <td>
              <el-radio-group v-model="replacementBillVo.deliveryPaymentType" disabled>
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </td>
            <td class="tableLabel">项目号：</td>
            <td>
              <el-input
                  v-model="replacementBillVo.faultSerialNO"
                  disabled
                  type="textarea"
                  autosize
                  placeholder="请输入"/>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">是否过质保：</td>
            <td>
              <el-radio-group v-model="replacementBillVo.underWarranty" disabled>
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </td>
            <td class="tableLabel">现场环境：</td>
            <td>
              <el-select v-model="replacementBillVo.environment" disabled placeholder="请选择">
                <el-option
                    v-for="item in constants.environment.$options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </td>
            <td class="tableLabel">故障发生阶段：</td>
            <td>
              <el-select v-model="replacementBillVo.stage" disabled placeholder="请选择">
                <el-option
                    v-for="item in constant.toSelect(constant.stage)"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">是否已技术支持：</td>
            <td>
              <el-radio-group v-model="replacementBillVo.isTechnicalSupport" disabled>
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </td>
            <td class="tableLabel">是否已质量核实：</td>
            <td>
              <el-radio-group v-model="replacementBillVo.isSurvey" disabled>
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </td>
            <td class="tableLabel">前序订单发运时间：</td>
            <td>
              {{replacementBillVo.completeEndDate}}
            </td>
          </tr>
          <tr>
            <td class="tableLabel">是否海外：</td>
            <td>
              <el-radio-group v-model="replacementBillVo.isOverseas" disabled>
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">收货地址：</td>
            <td colspan="5">{{replacementBillVo.deliveryAddress}}</td>
          </tr>
          <tr>
            <td class="tableLabel">备注：</td>
            <td colspan="5">{{replacementBillVo.note}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="调查结果">
        <table
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">调查结果：</td>
            <td>
              {{replacementBillVo.findings}}
            </td>
            <td class="tableLabel">责任划分：</td>
            <td>
              <div>
                <el-radio-group v-model="replacementBillVo.dutyType" disabled>
                  <el-radio :label="1">新时达责任</el-radio>
                  <el-radio :label="2">供应商责任</el-radio>
                  <el-radio :label="3">客户责任</el-radio>
                </el-radio-group>
              </div>
            </td>
            <td class="tableLabel">处理人：</td>
            <td>
              {{replacementBillVo.cqeApproveName}}
            </td>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">物料信息</div>
      <el-table
          :data="replacementBillVo.details">
        <el-table-column prop="materialNo" width="160" align="center" label="物料编号">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialNo" placeholder="请输入">
              <el-button slot="append" icon="el-icon-search" @click="openMaterialSelectDialog(scope.$index)"/>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="materialDesc" width="210" align="center" label="物料名称">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialDesc" placeholder="请输入" autosize type="textarea"/>
          </template>
        </el-table-column>
        <el-table-column prop="materialType" width="210" align="center" label="产品分类">
          <template slot-scope="scope">
            <el-select v-model="scope.row.materialType" clearable size="mini" placeholder="请选择">
              <el-option
                  v-for="item in constants.materialType.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="originalSoftware" width="140" align="center" label="原程序号">
          <template slot-scope="scope">
            <el-input v-model="scope.row.originalSoftware" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="presentSoftware" width="140" align="center" label="现程序号">
          <template slot-scope="scope">
            <el-input v-model="scope.row.presentSoftware" type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="mainPartsSerialNo" width="140" align="center" label="变频器/板卡条码">
          <template slot-scope="scope">
            <el-input v-model="scope.row.mainPartsSerialNo" type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="faultCode" width="100" align="center" label="故障码">
          <template slot-scope="scope">
            <el-input v-model="scope.row.faultCode" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="faultType" width="120" align="center" label="故障分类">
          <template slot-scope="scope">
            <el-select v-model="scope.row.faultType" clearable size="mini" placeholder="请选择">
              <el-option
                  v-for="item in constants.faultType.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" width="100" align="center" label="数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="unit" width="100" align="center" label="单位">
          <template slot-scope="scope">
            <el-input v-model="scope.row.unit" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryNote" width="120" align="center" label="备注">
          <template slot-scope="scope">
            <el-input v-model="scope.row.deliveryNote" type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="isNewRequest" width="100" align="center" label="是否新件">
          <template slot-scope="scope">
            <el-select v-model="scope.row.isNewRequest" clearable size="mini" placeholder="请选择">
              <el-option label="否" :value="0"/>
              <el-option label="是" :value="1"/>
              <el-option label="可新可旧" :value="2"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="problemType" width="120" align="center" label="问题分类">
          <template slot-scope="scope">
            <el-select
                v-if="replacementBillVo.billNo.includes('ZJ')"
                v-model="scope.row.problemType"
                clearable
                size="mini"
                placeholder="请选择">
              <el-option
                  v-for="(item,index) in constants.problemType.$options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
            <el-select
                v-else
                v-model="scope.row.problemType"
                clearable
                size="mini"
                placeholder="请选择">
              <el-option
                  v-for="(item,index) in constants.problemType2.$options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="responsibleDept" width="120" align="center" label="责任部门">
          <template slot-scope="scope">
            <el-select v-model="scope.row.responsibleDept" clearable size="mini" placeholder="请选择">
              <el-option
                  v-for="item in constants.responsibleDepartment.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryType" width="130" align="center" label="发运类型">
          <template slot-scope="scope">
            <el-input v-model="scope.row.deliveryType" placeholder="请选择">
              <el-button slot="append" icon="el-icon-search" @click="$refs.deliverySelect.open(scope.$index)"/>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryDate" label="发运日期" align="center" width="200"/>
        <el-table-column prop="deliveryPerson" width="120" align="center" label="发运人"/>
        <el-table-column prop="deliveryBillNo" width="120" align="center" label="发运单号">
          <template slot-scope="scope">
            <el-input v-model="scope.row.deliveryBillNo" type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="serialNo" width="120" align="center" label="发出-序列号"/>
        <el-table-column prop="deliveryWay" width="120" align="center" label="发运方式">
          <template slot-scope="scope">
            <el-input v-model="scope.row.deliveryWay" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="isMustBack" width="100" align="center" label="是否必退">
          <template slot-scope="scope">
            <el-select v-model="scope.row.isMustBack" clearable size="mini" placeholder="请选择">
              <el-option label="是" :value="true"/>
              <el-option label="否" :value="false"/>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
      <el-table
          ref="payData1"
          :data="replacementBillVo.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="primary" @click="downLoad(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
    <delivery-type-select ref="deliverySelect" @select="deliverySelect"/>
    <material-c-s-select ref="selectMaterial" @select="getDetails"/>
    <delivery-bill-print-other ref="deliveryPrintOther"/>
    <replacement-copy-edit ref="copyEdit"/>
  </div>
</template>

<script>
  import HandleDetail from "../../workFlow/HandleDetail.vue";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import constants from "@/util/constants.js";
  import DeliveryTypeSelect from "@/views/afterSalesManagement/Replacement/DeliveryTypeSelect";
  import MaterialCSSelect from "@/views/afterSalesManagement/Replacement/MaterialCSSelect";
  import DeliveryBillPrintOther from "@/views/afterSalesManagement/Replacement/DeliveryBillPrintOther";
  import ReplacementCopyEdit from "@/views/afterSalesManagement/Replacement/ReplacementCopyEdit";
  export default {
    name:"ReplacementPreview",
    components:{ReplacementCopyEdit, DeliveryBillPrintOther, MaterialCSSelect, DeliveryTypeSelect, HandleDetail},
    data() {
      return {
        constant,
        constants,
        addSaleLoading:false,
        deliveryLoading:false,
        addCsSpecialLoading:false,
        imgUrls: [],
        billId:"",
        billType:"13",
        pkid:"",
        replacementBillVo: {
          pkid: "",
          billNo: "",
          customerBillNo: "",
          createTime: "",
          creatorName: loginUtil.getName(),
          faultSerialNO: "",
          customerId: "",
          customerName: "",
          factoryNo: "",
          salesOrderNo: "", //出厂编号
          completeEndDate: "",
          contact: "",
          mobile: "",
          stage: "",
          consignee: "",
          consigneeMobile: "",
          deliveryType: "",
          deliveryAddress: "",
          note: "",
          attachments: [],
          details: [],
        },
      };
    },
    created() {
      this.billId = this.$route.query.billId;
      this.getData();
    },
    destroyed() {
      this.billId = "";
      this.replacementBillVo={};
    },
    methods:{
      getData() {
        this.$http.get("basic",`replacementBills/${this.billId}`).then((res)=>{
          this.replacementBillVo = res;
          this.replacementBillVo.attachments.forEach(row=>{
            if(row.filePath.includes("common")) {
              row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
              this.imgUrls.push(row.imgUrl);
            }else {
              row.imgUrl = "https://emes.stepelectric.com" + row.filePath;
              this.imgUrls.push(row.imgUrl);
            }
          });
        }).catch(()=>{
        });
      },
      addCsSpecialApplication() {
        this.addCsSpecialLoading = true;
        this.$http.post("basic", `csSpecialApplications/addCsSpecialApplication/${this.billId}`)
          .then(() => {
            this.$message.success("创建成功");
            this.addCsSpecialLoading = false;
          }).catch(() => {
            this.addCsSpecialLoading = false;
          });
      },
      // 物料选择对话框
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      getDetails(row,index) {
        this.replacementBillVo.details[index].materialId = row.id;
        this.replacementBillVo.details[index].materialDesc = row.name;
        this.replacementBillVo.details[index].materialNo = row.no;
      },
      deliverySelect(row) {
        this.replacementBillVo.details[row.groupIndex].deliveryType = row.deliveryTypeName;
        this.replacementBillVo.details[row.groupIndex].deliveryPerson = row.userName;
        this.replacementBillVo.details[row.groupIndex].deliveryAccount = row.account;
        this.replacementBillVo.details[row.groupIndex].setTime = row.setTime;
      },
      downLoad(row) {
        if(row.filePath.includes("common")) {
          let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }else {
          let a = document.createElement("a");
          a.href = "https://emes.stepelectric.com" + row.filePath;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }
      },
      deliveryPrint() {
        this.$refs.deliveryPrintOther.open(this.replacementBillVo);
      },
      deliveryPrint2() {
        this.deliveryLoading = true;
        this.$http.exportFile("basic",`replacementBills/deliveryPrint/${this.billId}`).then(res => {
          let blob = new Blob([res.data]);
          let fileName = this.replacementBillVo.billNo;
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName+".xls";
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
          this.deliveryLoading = false;
        }).catch(()=>{
          this.deliveryLoading = false;
        });
      },
      addSaleForm() {
        this.addSaleLoading = true;
        this.$http.get("basic",`replacementBills/createOrderByReplacementBill/${this.billId}`).then(() => {
          this.addSaleLoading = false;
          this.$message.success("创建成功");
        }).catch(()=>{
          this.addSaleLoading = false;
        });
      },
      copyBill() {
        this.$refs.copyEdit.open(this.replacementBillVo);
      },
    },
  };
</script>

<style lang="scss" scoped>
table.ProjectOrderTable {
  font-family: verdana,arial,sans-serif;
  font-size:18px;
  color:#333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
table.ProjectOrderTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}
table.ProjectOrderTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}
.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
